import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { LoadingController, ModalController } from '@ionic/angular';
import { Subject } from 'rxjs';
import { CalenderPage } from 'src/app/pages/calender/calender.page';
import { AlertService } from 'src/app/services/alert.service';
import { ApiService } from 'src/app/services/api.service';
import { FirestoreService } from 'src/app/services/firestore.service';
import { ToastService } from 'src/app/services/toast.service';
import { IClass } from 'src/app/shared/types/type.model';

import { format, formatISO, parseISO, } from 'date-fns';


@Component({
  selector: 'app-add-class',
  templateUrl: './add-class.component.html',
  styleUrls: ['./add-class.component.scss'],
})
export class AddClassComponent implements OnInit {
  dataForm: FormGroup;
  showWarnings: boolean = false;
  unsubscribe = new Subject();
  uploadPercentage: string = '0';
  profileImageUrl;

  imageUrl: string = '';
  imageEvent: string = '';
  imagePreview = null;

  @Input('data') data;
  @Input('isEditing') isEditing;

  constructor(
    private formBuilder: FormBuilder,
    private loadingCtrl: LoadingController,
    private firestoreService: FirestoreService,
    private toastService: ToastService,
    private modalCtrl: ModalController,
    private apiService : ApiService,
    private alertService : AlertService
  ) {}

  ngOnInit() {
    this.dataForm = this.formBuilder.group({
      name: new FormControl('', Validators.compose([Validators.required])),
      instructorName: new FormControl('', Validators.compose([Validators.required])),
      description: new FormControl('', Validators.compose([Validators.required])),
      day : new FormControl(''),
      startTime : new FormControl(''),
      endTime : new FormControl(''),
      startFromDate : new FormControl('', Validators.compose([Validators.required])),
      endDate : new FormControl('', Validators.compose([Validators.required]))
     
    });
    if (this.data) {
      this.data = {...this.data}
      console.log('Dtata here', this.data);
      if(this.data.startTime){
        this.data.startTime = this.data.startTime.toDate().toISOString();
      }
      if(this.data.endTime){
        this.data.endTime = this.data.endTime.toDate().toISOString();
      }
      this.data.startFromDate = this.data.startFromDate.toDate();
      this.data.endDate = this.data.endDate.toDate();
      this.dataForm.patchValue(this.data);
      this.imageUrl = this.data.photoUrl;
    }
  }

  dismissModal() {
    this.modalCtrl.dismiss();
  }

  async addData() {
    this.showWarnings = true;    

    if (this.dataForm.valid) {
      this.loadingCtrl
        .create({ keyboardClose: true, cssClass: 'loading-ctrl' })
        .then(async (loadingEl) => {
          loadingEl.present();

          if (this.isEditing) {
            let data: IClass = {
              ...this.dataForm.value,
              updatedDate: new Date(),
            };
            if(data.startTime){
              data.startTime = parseISO(this.dataForm.value.startTime)
            }
            if(data.endTime){
              data.endTime = parseISO(this.dataForm.value.endTime)
            }
            this.firestoreService
              .updateDocument(this.firestoreService.CLASSES, this.data.id, data)
              .subscribe((res) => {
                loadingEl.dismiss();
                this.toastService.presentToast('Class updated');
                this.modalCtrl.dismiss();
              });
          } else {
            let data: IClass = {
              ...this.dataForm.value,
              addedDate: new Date(),
            };
            if(data.startTime){
              data.startTime = parseISO(this.dataForm.value.startTime)
            }
            if(data.endTime){
              data.endTime = parseISO(this.dataForm.value.endTime)
            }
            this.firestoreService.addToCollection(this.firestoreService.CLASSES, data).subscribe(res=>{
              loadingEl.dismiss();
                  this.toastService.presentToast('Class added');
                  this.modalCtrl.dismiss();
            },(err=>{
              loadingEl.dismiss();
              console.log("Error", err);
              this.alertService.showFirebaseAlert(err);
            }))
          }
        });
    } else {
      this.toastService.presentToast(
        'All the fields should be filled and valid'
      );
    }
  }

  activeAditionalBackdrop = false;
  async changeDate(type: number, event: Event) {
    if(this.isEditing) return;
   if (!this.activeAditionalBackdrop) {
     console.log('Clicked once');

     const modal = await this.modalCtrl.create({
       component: CalenderPage,
       componentProps: {
         type: 'time',
       },
       cssClass: 'calender-modal',
       // mode: 'md',
       backdropDismiss: true,
       showBackdrop: true,
     });
     modal.onDidDismiss().then((data) => {
       this.activeAditionalBackdrop = false;
       if (data.data) {
         if (type == 1) this.dataForm.get('time')?.patchValue(data.data);
       }
     });
     this.activeAditionalBackdrop = true;
     event.preventDefault();
     event.stopPropagation();
     await modal.present();
   }
 }


 
}
